import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import { arrayToObject } from 'lib/array/arrayUtils'

type Response = paths['/api/lux-loyalty/claims/campaigns']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyActiveClaimCampaigns(): Promise<Record<string, App.LoyaltyClaimCampaign>> {
  const response = await requestUtils.get<Response>(
    '/api/lux-loyalty/claims/campaigns',
    { credentials: 'include', excludeBrand: true },
  )
  return arrayToObject(response.result.campaigns, campaign => campaign.id, campaign => ({
    ...campaign,
    description: campaign.description ?? undefined,
    startDate: campaign.startDate ?? undefined,
    endDate: campaign.endDate ?? undefined,
  }))
}

export default requestLoyaltyActiveClaimCampaigns
